import React from 'react'
import PropTypes from 'prop-types'
// material-ui components
import Slide from '@material-ui/core/Slide'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import AtlasForm from '../../components/AtlasForm/AtlasForm.js'

// core components
import Button from 'components/CustomButtons/Button.js'

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction="down" ref={ref} {...props} />
})

export default function Modal ({ title, modalOpen, dialogContentType, dialogFormProps, useBtnClose, dialogFormOnSubmit, callback, onClose }) {
  const [open, setOpen] = React.useState(modalOpen)
  const [btnClose, setBtnClose] = React.useState(useBtnClose)

  const handleClose = () => {
    setOpen(false)

    if (onClose !== undefined) {
      onClose()
    }
  }

  const handleCloseBtn = () => {
    setOpen(false)
    if (onClose !== undefined) {
      onClose()
    }
  }

  const onSuccess = (success) => {
    if (success) {
      setOpen(false)
      if (callback !== undefined) {
        callback()
      }
    }
  }

  React.useEffect(() => {
    if (modalOpen === undefined) {
      setOpen(false)
    }

    if (useBtnClose === undefined) {
      setBtnClose(false)
    }
  }, [])

  React.useEffect(() => {
    setOpen(modalOpen)
  }, [modalOpen])

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={btnClose === false ? handleClose : null}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description">
        <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
        <DialogContent >
          {dialogContentType === 'form'
            ? <AtlasForm formData={dialogFormProps} onSubmit={dialogFormOnSubmit} onSuccess={onSuccess}/>
            : <div/>}
        </DialogContent>
        <DialogActions>
          {btnClose === true
            ? <Button variant="outlined" color="primary" onClick={handleCloseBtn}>
            Close
            </Button>
            : ''}
        </DialogActions>
      </Dialog>
    </div>
  )
}

Modal.propTypes = {
  title: PropTypes.string,
  modalOpen: PropTypes.bool,
  dialogContent: PropTypes.element,
  dialogContentType: PropTypes.string,
  dialogFormProps: PropTypes.object,
  useBtnClose: PropTypes.bool,
  dialogFormOnSubmit: PropTypes.func,
  callback: PropTypes.func,
  onClose: PropTypes.func
}
